import React, { useState } from 'react'
import { Button } from 'reactstrap'
import i18n from 'i18n/config'

const CommissionCell = ({ value }) => {
  const [isHover, setIsHover] = useState(false)
  const taxLabel = value ? value : i18n.t('products_catalog_grid_options.pending_assignment')

  return (
    <Button
      color="primary"
      size="sm"
      className="text-white fw-semibold"
      style={{ width: '150px' }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {isHover
        ? taxLabel
        : i18n.t('products_catalog_grid_options.click_to_show')}
    </Button>
  )
}

const getColumns = (data, params) => [
  {
    Header: '',
    accessor: 'row',
    Cell: ({ state, row }) => state.pageSize * state.pageIndex + (row.index + 1),
    sortable: false,
    justifyContent: 'center',
    width: 20,
  },
  {
    Header: i18n.t('products_catalog_grid_options.type'),
    accessor: 'type',
    sortable: false,
    justifyContent: 'center',
    width: 50,
  },
  {
    Header: i18n.t('products_catalog_grid_options.state'),
    accessor: 'state_id',
    sortable: false,
    justifyContent: 'center',
    Cell: ({ row }) => row.original.state_label,
    width: 80,
  },
  {
    Header: i18n.t('products_catalog_grid_options.product'),
    accessor: 'title',
    sortable: false,
    width: 400,
  },
  {
    Header: i18n.t('products_catalog_grid_options.featured_price'),
    accessor: 'featured_price_label',
    sortable: false,
    justifyContent: 'flex-end',
    width: 100,
  },
  {
    Header: i18n.t('products_catalog_grid_options.type'),
    accessor: 'main_commission',
    sortable: false,
    justifyContent: 'center',
    Cell: ({ value }) => <CommissionCell value={value} />,
    width: 150,
  },
]

const tableOptions = (data, params) => ({
  columns: getColumns(data, params),
})

export default tableOptions
